import { elementType, func, string, oneOfType, node } from 'prop-types';
import React from 'react';
import FieldWithErrorLabel from '../FieldWithErrorLabel';
import LabeledBlock from '../LabeledBlock';

const LabeledFieldWithErrorLabel = ({
  label,
  labelColor,
  labelFontSize,
  labelAs: LabelComp,
  ...rest
}) => (
  <LabeledBlock label={label} as={LabelComp} color={labelColor} fontSize={labelFontSize}>
    <FieldWithErrorLabel {...rest} />
  </LabeledBlock>
);

LabeledFieldWithErrorLabel.propTypes = {
  label: string,
  labelColor: string,
  labelFontSize: string,
  name: string.isRequired,
  children: oneOfType([node, func]),
  type: string,
  as: elementType,
  width: string,
  labelAs: elementType,
  validate: func,
};

export default LabeledFieldWithErrorLabel;
